
  import React from "react"
  import Component from "/Users/usuario/ggseco/src/layouts/index.js"
  import data from "/Users/usuario/ggseco/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js